import { isDesktop, isMobile, navigateTo } from "../../lib/helper";
import { Component } from "react";
import { withTranslation } from "react-i18next";
import { connect } from "react-redux";
import { useSnackbar } from "notistack";
import { withRouter } from "react-router-dom";

class Verified extends Component {
    super(props) {
        this.state = {}
    }
    render() {
        const { t } = this.props;
        return (
            <div data-v-682ccdfa="" data-v-b0e45e8c="" className="boxFix">
                <div data-v-682ccdfa="" className="boxAuthentication show">
                    <div data-v-682ccdfa=""
                        className={`contentAuthentication d-flex flex-column align-items-center`}
                        style={{
                            position: 'fixed',
                            width: isDesktop() ? '500px' : '100%',
                            right: '0',
                            padding: '170px , 150px ,0px , 150px'
                        }}>
                        <div data-v-682ccdfa=""
                            className="header  position-absolute px-3 d-flex align-items-center justify-content-between w-100"><a
                                style={{ backgroundImage: 'url(/images/logo-main.png?ver=1182835)', backgroundSize: 'cover' }}
                                data-v-682ccdfa="" href="/login" className="logoLogin mb-0 router-link-active">BONAX</a>
                            <div data-v-f99ecb42="" onClick={navigateTo('/').bind(this)} className="close-page">
                                <span data-v-f99ecb42="" className="pe pe-7s-close" />
                            </div>
                        </div>
                        <form style={{ top: '50%', left: '50%', transform: 'translate(-50%,-50%)' }}
                            className='loginForm position-absolute w-100 d-flex flex-column align-items-center justify-content-center h-100 colorWhite'>
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width={104}
                                height={70}
                                fill="none"
                            >
                                <path
                                    fill="url(#a)"
                                    fillRule="evenodd"
                                    d="M103.428 70c0-28.403-23.025-51.429-51.428-51.429S.57 41.597.57 70h102.857Z"
                                    clipRule="evenodd"
                                    opacity={0.1}
                                />
                                <mask
                                    id="b"
                                    width={70}
                                    height={70}
                                    x={17}
                                    y={0}
                                    maskUnits="userSpaceOnUse"
                                    style={{
                                        maskType: "luminance",
                                    }}
                                >
                                    <path fill="#fff" d="M17 0h70v70H17V0Z" />
                                </mask>
                                <g fill="#30E0A1" fillRule="evenodd" clipRule="evenodd" mask="url(#b)">
                                    <path
                                        d="M17 35c0 19.33 15.67 35 35 35s35-15.67 35-35S71.33 0 52 0 17 15.67 17 35Zm35 32.95c-18.197 0-32.95-14.753-32.95-32.95C19.05 16.803 33.804 2.05 52 2.05c18.197 0 32.95 14.753 32.95 32.95 0 18.197-14.753 32.95-32.95 32.95Z" />
                                    <path
                                        d="M32.993 58.244A29.905 29.905 0 0 0 52 65.024c16.582 0 30.025-13.442 30.025-30.024S68.582 4.975 52 4.975 21.976 18.418 21.976 35a29.912 29.912 0 0 0 7.273 19.593 1.026 1.026 0 0 0 1.554-1.339A27.86 27.86 0 0 1 24.026 35C24.026 19.55 36.551 7.026 52 7.026 67.45 7.026 79.974 19.55 79.974 35c0 15.45-12.524 27.974-27.974 27.974a27.855 27.855 0 0 1-17.708-6.317 1.025 1.025 0 1 0-1.299 1.587Z" />
                                    <path
                                        d="M50.305 46.956a3.999 3.999 0 0 1-5.655 0l-9.467-9.467a1.76 1.76 0 0 1 0-2.487l3.695-3.695a1.759 1.759 0 0 1 2.487 0l5.66 5.659c.4.4 1.05.4 1.45 0l14.431-14.431a1.759 1.759 0 0 1 2.488 0l3.422 3.422a1.76 1.76 0 0 1 0 2.488l-12.36 12.36a1.025 1.025 0 0 0 1.45 1.45l12.36-12.36a3.81 3.81 0 0 0 0-5.388l-3.422-3.422a3.81 3.81 0 0 0-5.388 0L47.75 34.79l-4.934-4.934a3.81 3.81 0 0 0-5.388 0l-3.695 3.695a3.81 3.81 0 0 0 0 5.387l9.467 9.467a6.05 6.05 0 0 0 8.555 0l2.733-2.734a1.025 1.025 0 0 0-1.45-1.45l-2.733 2.734Z" />
                                    <path
                                        d="M44.447 39.544c.4.4 1.05.4 1.45 0l2.578-2.578a1.025 1.025 0 1 0-1.45-1.45l-2.578 2.578c-.4.4-.4 1.05 0 1.45Z" />
                                </g>
                                <defs>
                                    <linearGradient
                                        id="a"
                                        x1={52}
                                        x2={52}
                                        y1={18.571}
                                        y2={70}
                                        gradientUnits="userSpaceOnUse"
                                    >
                                        <stop stopColor="#30E0A1" />
                                        <stop offset={1} stopColor="#30E0A1" stopOpacity={0} />
                                    </linearGradient>
                                </defs>
                            </svg>
                            <h2 className={`mt-5 color-white font-weight-bold mb-lg-5 mb-3 text-left ${isDesktop() ? 'font-25' : 'font-22'}`}>Kích
                                hoạt tài khoản thành công</h2>
                        </form>
                        <p data-v-682ccdfa=""
                            className="text-text text-left position-absolute mt-lg-4 mt-3 bottom-1rem">
                            {t('HaveAnAccount')}
                            <a data-v-682ccdfa="" href="#" onClick={navigateTo('login').bind(this)}
                                className="colorBlue4">{t('LoginToYourAccount')} </a>
                        </p>
                    </div>
                </div>
                <div data-v-682ccdfa="" tabIndex="-1" role="dialog" aria-hidden="true"
                    className="modal fade">
                    <div className="modal-dialog">
                        <div className="modal-content">
                            <div className="panel" />
                        </div>
                    </div>
                </div>
            </div>

        )
    }
}

function mapStateToProps(state) {
    return {
        memberReducer: state.memberReducer,
        appReducer: state.appReducer
    };
}

const withSnackbar = (Component) => (props) => {
    const { enqueueSnackbar } = useSnackbar();
    return <Component {...props} enqueueSnackbar={enqueueSnackbar} />;
};

export default withRouter(connect(mapStateToProps, {
})(withSnackbar(withTranslation()(Verified))));

